/**
 * @description 태그 관련 쿼리 키 모음
 * availableTags: 자산 태그 트리 노드 관련
 * categories: 태그 분류(카테고리) 목록 조회 키 (좌측 트리 루트)
 * categoryDetail: 태그 분류(카테고리) 상세 조회 키
 * tags: 특정 parent 아래 하위 태그 목록 조회 키 (좌측 트리 펼침/로딩)
 * tagDetail: 태그 상세 조회 키
 *
 * tagsByCategory/tagsByCategoryDetail: 태그 분류 하위 태그 목록(테이블/상세) 조회 키
 * - tagsByCategoryDetail 쿼리 키는 searchTagsApi 내에서 filter 조건 후 반환하고 있음
 * - 따라서 하위의 태그 목록 초기화를 위해 tagsByCategory 캐시를 무효화하기 위한 tagsByCategory 쿼리 키 생성
 *
 * certificationAssets/certificationAssetsCount: "태그 자산" 탭(목록/카운트) 조회 키
 * certificationAssetsPrefix/certificationAssetsCountPrefix: 위 탭 캐시 무효화를 위한 prefix 키
 */

const TAG_KEYS_ROOT = ['tags'] as const;

export const tagKeys = {
  all: TAG_KEYS_ROOT,

  availableTags: () => [...TAG_KEYS_ROOT, 'availableTags'] as const,

  certificationAssetsPrefix: () => [...TAG_KEYS_ROOT, 'certificationAssets'] as const,
  certificationAssets: (
    certificationTagFqn: string,
    filters: unknown,
    query: string,
    sortBy: string,
    sortOrder: string
  ) => [...tagKeys.certificationAssetsPrefix(), certificationTagFqn, filters, query, sortBy, sortOrder] as const,

  certificationAssetsCountPrefix: () => [...TAG_KEYS_ROOT, 'certificationAssetsCount'] as const,
  certificationAssetsCount: (certificationTagFqn: string) =>
    [...tagKeys.certificationAssetsCountPrefix(), certificationTagFqn] as const,

  categories: () => [...TAG_KEYS_ROOT, 'categories'] as const,
  categoryDetail: (categoryName: string) => [...TAG_KEYS_ROOT, 'categoryDetail', categoryName] as const,

  tagsByCategoryPrefix: () => [...TAG_KEYS_ROOT, 'tagsByCategory'] as const,
  tagsByCategory: (parent: string) => [...tagKeys.tagsByCategoryPrefix(), parent] as const,
  tagsByCategoryDetail: (parent: string, query?: string, provider?: string) =>
    [...tagKeys.tagsByCategoryPrefix(), parent, query, provider] as const,

  tags: (parent: string) => [...TAG_KEYS_ROOT, 'tags', parent] as const,
  tagDetail: (tagName: string) => [...TAG_KEYS_ROOT, 'tagDetail', tagName] as const,
} as const;
